import axios from 'axios';
import Cookies from 'js-cookie';

const types = {
  VALIDATE_TOKEN: 'VALIDATE_TOKEN',
  VALIDATE_TOKEN_FULFILLED: 'VALIDATE_TOKEN_FULFILLED',
  VALIDATE_TOKEN_REJECTED: 'VALIDATE_TOKEN_REJECTED'
};

function doValidateUser(redirectPath) {
  const token = localStorage.getItem('token');
  return () => axios.post('/validatetoken', { token })
  .then((response) => {
    if (response.data.valid) {
      return axios.post('/userDefinitions', { token });
    }
    Cookies.set('redierctURL', redirectPath);
    return response;
  }).then((response) => response.data);
}

function validateToken(redirectPath) {
  const aciton = {
    type: 'API',
    types: [types.VALIDATE_TOKEN, types.VALIDATE_TOKEN_FULFILLED, types.VALIDATE_TOKEN_REJECTED],
    api: doValidateUser(redirectPath),
    payload: {
      url: redirectPath
    }
  };
  return aciton;
}

const actions = {
  validateToken
};

export {
  types,
  actions
};